export interface TextMeasurer {
  measure(text: string, font: string): number;
}

class TextMeasureHelper {
  // Canvas cannot read CSS variables, so the chart names the font stack the page renders these in.
  static readonly FONT_FAMILY =
    '"Inter Variable", Inter, ui-sans-serif, system-ui, sans-serif';

  static readonly LABEL_FONT = `400 12px ${TextMeasureHelper.FONT_FAMILY}`;

  static readonly CHIP_FONT = TextMeasureHelper.LABEL_FONT;

  static readonly FALLBACK_CHAR_WIDTH = 6.5;

  static createFixedWidthMeasurer(
    charWidth = TextMeasureHelper.FALLBACK_CHAR_WIDTH
  ): TextMeasurer {
    return { measure: (text) => text.length * charWidth };
  }

  // Measure after document.fonts.ready, or the widths come from the fallback font.
  static createCanvasMeasurer(): TextMeasurer {
    const context =
      typeof document === 'undefined'
        ? null
        : document.createElement('canvas').getContext('2d');
    if (!context) return TextMeasureHelper.createFixedWidthMeasurer();
    const cache = new Map<string, number>();
    return {
      measure: (text, font) => {
        const key = `${font}|${text}`;
        const cached = cache.get(key);
        if (cached !== undefined) return cached;
        context.font = font;
        const { width } = context.measureText(text);
        cache.set(key, width);
        return width;
      },
    };
  }
}

export { TextMeasureHelper };
